export const FEATURES = {
  commissions: false,
};
